import axios from 'axios';
import { API_DOMAIN } from 'constants/api';
import { useEffect } from 'react';

const DownloadApp = () => {
    const toPageDownload = (url) => {
        window.location = url;
    };
    useEffect(() => {
        const getDevide = async () => {
            try {
                const response = await axios.get(`${API_DOMAIN}mobile-app/A`);
                const url = response?.data?.url;
                toPageDownload(url);
            } catch (err) {
                console.log('ERROR: ', err);
            }
        };
        getDevide();
    }, []);
    return <></>;
};

export default DownloadApp;
